module.exports = __webpack_public_path__ + "img/logout.f27443da.png";